import { Dict } from '@se/se.platform.base';

// #region Interfaces

export interface ISeSidePatientHistoryFeatureState { 
    patientId: string; // paziente dui cui si carica la storia
    selectedItem: any; // Elemento della storia selezionato
    message: string; // Messaggio visulaizzato quando non ci soo items (pe rerrori, zero result o altro)
}

// #endregion

// #region Types

export type SeSidePatientHistoryState = Dict<ISeSidePatientHistoryFeatureState>;

// #endregion

// #region States

export const seSidePatientHistoryInitialState: SeSidePatientHistoryState = {
    ecg: {
        patientId: null,
        selectedItem: null,
        message: null
    }
};

// #endregion
